import React from "react";

export const LargeIcon = ({ icon: Icon }) => {
  return <Icon style={{ fontSize: "20px" }} />;
};
